import {QueryString} from "../../common/api/model/QueryString";

export class PortalQueryString extends QueryString {
    static ID = "id";
}
